// 自动生成的照片列表
export const loadPhotos = async () => {
  return [
  {
    "original": "/assets/images/02fb9407cb485c234e18b9977e096010.png",
    "thumbnail": "/assets/images/thumbnails/02fb9407cb485c234e18b9977e096010.png",
    "filename": "02fb9407cb485c234e18b9977e096010.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/083acc20f4e0742606ffd626ef120657.png",
    "thumbnail": "/assets/images/thumbnails/083acc20f4e0742606ffd626ef120657.png",
    "filename": "083acc20f4e0742606ffd626ef120657.png",
    "width": 0,
    "height": 0,
    "size": 27780382
  },
  {
    "original": "/assets/images/0a0fbd12b892f8edd1c7b4949a78bd12-1.JPEG",
    "thumbnail": "/assets/images/thumbnails/0a0fbd12b892f8edd1c7b4949a78bd12-1.JPEG",
    "filename": "0a0fbd12b892f8edd1c7b4949a78bd12-1.JPEG",
    "width": 0,
    "height": 0,
    "size": 980798
  },
  {
    "original": "/assets/images/0a0fbd12b892f8edd1c7b4949a78bd12.JPEG",
    "thumbnail": "/assets/images/thumbnails/0a0fbd12b892f8edd1c7b4949a78bd12.JPEG",
    "filename": "0a0fbd12b892f8edd1c7b4949a78bd12.JPEG",
    "width": 0,
    "height": 0,
    "size": 5658710
  },
  {
    "original": "/assets/images/0a33c04d1ab8315ad0093cd607eb4c5e.png",
    "thumbnail": "/assets/images/thumbnails/0a33c04d1ab8315ad0093cd607eb4c5e.png",
    "filename": "0a33c04d1ab8315ad0093cd607eb4c5e.png",
    "width": 0,
    "height": 0,
    "size": 19998271
  },
  {
    "original": "/assets/images/0b033e30f5fb70b049aa680f621abc17.jpg",
    "thumbnail": "/assets/images/thumbnails/0b033e30f5fb70b049aa680f621abc17.jpg",
    "filename": "0b033e30f5fb70b049aa680f621abc17.jpg",
    "width": 0,
    "height": 0,
    "size": 53255
  },
  {
    "original": "/assets/images/1db786edae1de176c71860395c1d40e8.png",
    "thumbnail": "/assets/images/thumbnails/1db786edae1de176c71860395c1d40e8.png",
    "filename": "1db786edae1de176c71860395c1d40e8.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/1e4c353838e51f96a323f99700128a0f.JPEG",
    "thumbnail": "/assets/images/thumbnails/1e4c353838e51f96a323f99700128a0f.JPEG",
    "filename": "1e4c353838e51f96a323f99700128a0f.JPEG",
    "width": 0,
    "height": 0,
    "size": 4741078
  },
  {
    "original": "/assets/images/2186455cd290940e61005cd63c340944.JPEG",
    "thumbnail": "/assets/images/thumbnails/2186455cd290940e61005cd63c340944.JPEG",
    "filename": "2186455cd290940e61005cd63c340944.JPEG",
    "width": 0,
    "height": 0,
    "size": 359573
  },
  {
    "original": "/assets/images/2186455cd290940e61005cd63c340944.png",
    "thumbnail": "/assets/images/thumbnails/2186455cd290940e61005cd63c340944.png",
    "filename": "2186455cd290940e61005cd63c340944.png",
    "width": 0,
    "height": 0,
    "size": 21339972
  },
  {
    "original": "/assets/images/2ece72900a323d52ea70b0202a30324e.png",
    "thumbnail": "/assets/images/thumbnails/2ece72900a323d52ea70b0202a30324e.png",
    "filename": "2ece72900a323d52ea70b0202a30324e.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/2f298cb0206edc6308d23a1a3f2c63d9-1.JPEG",
    "thumbnail": "/assets/images/thumbnails/2f298cb0206edc6308d23a1a3f2c63d9-1.JPEG",
    "filename": "2f298cb0206edc6308d23a1a3f2c63d9-1.JPEG",
    "width": 0,
    "height": 0,
    "size": 3704021
  },
  {
    "original": "/assets/images/2f298cb0206edc6308d23a1a3f2c63d9.JPEG",
    "thumbnail": "/assets/images/thumbnails/2f298cb0206edc6308d23a1a3f2c63d9.JPEG",
    "filename": "2f298cb0206edc6308d23a1a3f2c63d9.JPEG",
    "width": 0,
    "height": 0,
    "size": 639135
  },
  {
    "original": "/assets/images/3dee0c15ea44a333fe50fcd4db6b0618.png",
    "thumbnail": "/assets/images/thumbnails/3dee0c15ea44a333fe50fcd4db6b0618.png",
    "filename": "3dee0c15ea44a333fe50fcd4db6b0618.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/4171206f910cb3e84003d71cb94bba8b-1.JPEG",
    "thumbnail": "/assets/images/thumbnails/4171206f910cb3e84003d71cb94bba8b-1.JPEG",
    "filename": "4171206f910cb3e84003d71cb94bba8b-1.JPEG",
    "width": 0,
    "height": 0,
    "size": 3729586
  },
  {
    "original": "/assets/images/4171206f910cb3e84003d71cb94bba8b.JPEG",
    "thumbnail": "/assets/images/thumbnails/4171206f910cb3e84003d71cb94bba8b.JPEG",
    "filename": "4171206f910cb3e84003d71cb94bba8b.JPEG",
    "width": 0,
    "height": 0,
    "size": 779251
  },
  {
    "original": "/assets/images/44d2442c76d275473172ea00b475a37a.JPEG",
    "thumbnail": "/assets/images/thumbnails/44d2442c76d275473172ea00b475a37a.JPEG",
    "filename": "44d2442c76d275473172ea00b475a37a.JPEG",
    "width": 0,
    "height": 0,
    "size": 606903
  },
  {
    "original": "/assets/images/5cea963638c713d3b38c8637f1d182ea.JPEG",
    "thumbnail": "/assets/images/thumbnails/5cea963638c713d3b38c8637f1d182ea.JPEG",
    "filename": "5cea963638c713d3b38c8637f1d182ea.JPEG",
    "width": 0,
    "height": 0,
    "size": 5059734
  },
  {
    "original": "/assets/images/77d3136d6ae1be6bb90d3d10e3070ee0.JPEG",
    "thumbnail": "/assets/images/thumbnails/77d3136d6ae1be6bb90d3d10e3070ee0.JPEG",
    "filename": "77d3136d6ae1be6bb90d3d10e3070ee0.JPEG",
    "width": 0,
    "height": 0,
    "size": 3940304
  },
  {
    "original": "/assets/images/84170adea5078893ca49b2ad44151637.png",
    "thumbnail": "/assets/images/thumbnails/84170adea5078893ca49b2ad44151637.png",
    "filename": "84170adea5078893ca49b2ad44151637.png",
    "width": 0,
    "height": 0,
    "size": 19682300
  },
  {
    "original": "/assets/images/847cdd0f68aac2fdc77f70b4749f0582-1.png",
    "thumbnail": "/assets/images/thumbnails/847cdd0f68aac2fdc77f70b4749f0582-1.png",
    "filename": "847cdd0f68aac2fdc77f70b4749f0582-1.png",
    "width": 0,
    "height": 0,
    "size": 20820603
  },
  {
    "original": "/assets/images/847cdd0f68aac2fdc77f70b4749f0582.png",
    "thumbnail": "/assets/images/thumbnails/847cdd0f68aac2fdc77f70b4749f0582.png",
    "filename": "847cdd0f68aac2fdc77f70b4749f0582.png",
    "width": 0,
    "height": 0,
    "size": 20820603
  },
  {
    "original": "/assets/images/872f128fc8c3a174a8ca4867c1a11fd0.png",
    "thumbnail": "/assets/images/thumbnails/872f128fc8c3a174a8ca4867c1a11fd0.png",
    "filename": "872f128fc8c3a174a8ca4867c1a11fd0.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/8ead4ce37852e5b1e20765c0dc0dbfeb.JPEG",
    "thumbnail": "/assets/images/thumbnails/8ead4ce37852e5b1e20765c0dc0dbfeb.JPEG",
    "filename": "8ead4ce37852e5b1e20765c0dc0dbfeb.JPEG",
    "width": 0,
    "height": 0,
    "size": 177069
  },
  {
    "original": "/assets/images/8f26ec70e16ad58633040ffe831ae36a-1.JPEG",
    "thumbnail": "/assets/images/thumbnails/8f26ec70e16ad58633040ffe831ae36a-1.JPEG",
    "filename": "8f26ec70e16ad58633040ffe831ae36a-1.JPEG",
    "width": 0,
    "height": 0,
    "size": 5348030
  },
  {
    "original": "/assets/images/8f26ec70e16ad58633040ffe831ae36a.JPEG",
    "thumbnail": "/assets/images/thumbnails/8f26ec70e16ad58633040ffe831ae36a.JPEG",
    "filename": "8f26ec70e16ad58633040ffe831ae36a.JPEG",
    "width": 0,
    "height": 0,
    "size": 1621913
  },
  {
    "original": "/assets/images/IMG_0071.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_0071.JPG",
    "filename": "IMG_0071.JPG",
    "width": 0,
    "height": 0,
    "size": 1685869
  },
  {
    "original": "/assets/images/IMG_0072.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_0072.JPG",
    "filename": "IMG_0072.JPG",
    "width": 0,
    "height": 0,
    "size": 1746428
  },
  {
    "original": "/assets/images/IMG_2008.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_2008.JPG",
    "filename": "IMG_2008.JPG",
    "width": 0,
    "height": 0,
    "size": 4585931
  },
  {
    "original": "/assets/images/IMG_2009.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_2009.JPG",
    "filename": "IMG_2009.JPG",
    "width": 0,
    "height": 0,
    "size": 7136033
  },
  {
    "original": "/assets/images/IMG_2010.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_2010.JPG",
    "filename": "IMG_2010.JPG",
    "width": 0,
    "height": 0,
    "size": 5005940
  },
  {
    "original": "/assets/images/IMG_2680.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_2680.PNG",
    "filename": "IMG_2680.PNG",
    "width": 0,
    "height": 0,
    "size": 3008182
  },
  {
    "original": "/assets/images/IMG_3379.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3379.JPG",
    "filename": "IMG_3379.JPG",
    "width": 0,
    "height": 0,
    "size": 5241908
  },
  {
    "original": "/assets/images/IMG_3383.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3383.JPEG",
    "filename": "IMG_3383.JPEG",
    "width": 0,
    "height": 0,
    "size": 5061277
  },
  {
    "original": "/assets/images/IMG_3384.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3384.JPEG",
    "filename": "IMG_3384.JPEG",
    "width": 0,
    "height": 0,
    "size": 3213537
  },
  {
    "original": "/assets/images/IMG_3388.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3388.JPEG",
    "filename": "IMG_3388.JPEG",
    "width": 0,
    "height": 0,
    "size": 4635748
  },
  {
    "original": "/assets/images/IMG_3396.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3396.JPG",
    "filename": "IMG_3396.JPG",
    "width": 0,
    "height": 0,
    "size": 4381379
  },
  {
    "original": "/assets/images/IMG_3397.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3397.JPEG",
    "filename": "IMG_3397.JPEG",
    "width": 0,
    "height": 0,
    "size": 5741913
  },
  {
    "original": "/assets/images/IMG_3399.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3399.JPEG",
    "filename": "IMG_3399.JPEG",
    "width": 0,
    "height": 0,
    "size": 5421795
  },
  {
    "original": "/assets/images/IMG_3400.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3400.JPEG",
    "filename": "IMG_3400.JPEG",
    "width": 0,
    "height": 0,
    "size": 1083283
  },
  {
    "original": "/assets/images/IMG_3401.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3401.JPG",
    "filename": "IMG_3401.JPG",
    "width": 0,
    "height": 0,
    "size": 2807030
  },
  {
    "original": "/assets/images/IMG_3412.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3412.JPG",
    "filename": "IMG_3412.JPG",
    "width": 0,
    "height": 0,
    "size": 4953975
  },
  {
    "original": "/assets/images/IMG_3413.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3413.JPEG",
    "filename": "IMG_3413.JPEG",
    "width": 0,
    "height": 0,
    "size": 3788228
  },
  {
    "original": "/assets/images/IMG_3416.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3416.JPEG",
    "filename": "IMG_3416.JPEG",
    "width": 0,
    "height": 0,
    "size": 4314549
  },
  {
    "original": "/assets/images/IMG_3417.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3417.JPG",
    "filename": "IMG_3417.JPG",
    "width": 0,
    "height": 0,
    "size": 4628739
  },
  {
    "original": "/assets/images/IMG_3418.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3418.JPG",
    "filename": "IMG_3418.JPG",
    "width": 0,
    "height": 0,
    "size": 4220089
  },
  {
    "original": "/assets/images/IMG_3421.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3421.JPG",
    "filename": "IMG_3421.JPG",
    "width": 0,
    "height": 0,
    "size": 3892323
  },
  {
    "original": "/assets/images/IMG_3441.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3441.JPG",
    "filename": "IMG_3441.JPG",
    "width": 0,
    "height": 0,
    "size": 4633808
  },
  {
    "original": "/assets/images/IMG_3626.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3626.JPG",
    "filename": "IMG_3626.JPG",
    "width": 0,
    "height": 0,
    "size": 12980309
  },
  {
    "original": "/assets/images/IMG_3627.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3627.JPG",
    "filename": "IMG_3627.JPG",
    "width": 0,
    "height": 0,
    "size": 10192390
  },
  {
    "original": "/assets/images/IMG_3747.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3747.JPEG",
    "filename": "IMG_3747.JPEG",
    "width": 0,
    "height": 0,
    "size": 2859876
  },
  {
    "original": "/assets/images/IMG_3748.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3748.JPG",
    "filename": "IMG_3748.JPG",
    "width": 0,
    "height": 0,
    "size": 2489167
  },
  {
    "original": "/assets/images/IMG_3749.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3749.JPG",
    "filename": "IMG_3749.JPG",
    "width": 0,
    "height": 0,
    "size": 2614057
  },
  {
    "original": "/assets/images/IMG_3752.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3752.JPG",
    "filename": "IMG_3752.JPG",
    "width": 0,
    "height": 0,
    "size": 2211899
  },
  {
    "original": "/assets/images/IMG_3753.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3753.JPEG",
    "filename": "IMG_3753.JPEG",
    "width": 0,
    "height": 0,
    "size": 2950814
  },
  {
    "original": "/assets/images/IMG_3756.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3756.JPEG",
    "filename": "IMG_3756.JPEG",
    "width": 0,
    "height": 0,
    "size": 3122722
  },
  {
    "original": "/assets/images/IMG_3758.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3758.JPG",
    "filename": "IMG_3758.JPG",
    "width": 0,
    "height": 0,
    "size": 2656189
  },
  {
    "original": "/assets/images/IMG_3759.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3759.JPG",
    "filename": "IMG_3759.JPG",
    "width": 0,
    "height": 0,
    "size": 2670211
  },
  {
    "original": "/assets/images/IMG_3760.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3760.JPG",
    "filename": "IMG_3760.JPG",
    "width": 0,
    "height": 0,
    "size": 2543500
  },
  {
    "original": "/assets/images/IMG_3763.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3763.JPG",
    "filename": "IMG_3763.JPG",
    "width": 0,
    "height": 0,
    "size": 2341126
  },
  {
    "original": "/assets/images/IMG_3764.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3764.JPG",
    "filename": "IMG_3764.JPG",
    "width": 0,
    "height": 0,
    "size": 2459921
  },
  {
    "original": "/assets/images/IMG_3766.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3766.JPG",
    "filename": "IMG_3766.JPG",
    "width": 0,
    "height": 0,
    "size": 2704679
  },
  {
    "original": "/assets/images/IMG_3768.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_3768.JPEG",
    "filename": "IMG_3768.JPEG",
    "width": 0,
    "height": 0,
    "size": 2611358
  },
  {
    "original": "/assets/images/IMG_3897.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3897.JPG",
    "filename": "IMG_3897.JPG",
    "width": 0,
    "height": 0,
    "size": 6220305
  },
  {
    "original": "/assets/images/IMG_3942.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3942.JPG",
    "filename": "IMG_3942.JPG",
    "width": 0,
    "height": 0,
    "size": 1728676
  },
  {
    "original": "/assets/images/IMG_3943.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3943.JPG",
    "filename": "IMG_3943.JPG",
    "width": 0,
    "height": 0,
    "size": 3264933
  },
  {
    "original": "/assets/images/IMG_3945.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_3945.JPG",
    "filename": "IMG_3945.JPG",
    "width": 0,
    "height": 0,
    "size": 3044444
  },
  {
    "original": "/assets/images/IMG_4041.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4041.JPG",
    "filename": "IMG_4041.JPG",
    "width": 0,
    "height": 0,
    "size": 413541
  },
  {
    "original": "/assets/images/IMG_4096.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4096.JPG",
    "filename": "IMG_4096.JPG",
    "width": 0,
    "height": 0,
    "size": 29623
  },
  {
    "original": "/assets/images/IMG_4115.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4115.JPG",
    "filename": "IMG_4115.JPG",
    "width": 0,
    "height": 0,
    "size": 719929
  },
  {
    "original": "/assets/images/IMG_4209.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4209.JPG",
    "filename": "IMG_4209.JPG",
    "width": 0,
    "height": 0,
    "size": 3653954
  },
  {
    "original": "/assets/images/IMG_4225.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4225.PNG",
    "filename": "IMG_4225.PNG",
    "width": 0,
    "height": 0,
    "size": 727527
  },
  {
    "original": "/assets/images/IMG_4226.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4226.PNG",
    "filename": "IMG_4226.PNG",
    "width": 0,
    "height": 0,
    "size": 552421
  },
  {
    "original": "/assets/images/IMG_4227.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4227.PNG",
    "filename": "IMG_4227.PNG",
    "width": 0,
    "height": 0,
    "size": 726784
  },
  {
    "original": "/assets/images/IMG_4228.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4228.PNG",
    "filename": "IMG_4228.PNG",
    "width": 0,
    "height": 0,
    "size": 3377691
  },
  {
    "original": "/assets/images/IMG_4229.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4229.PNG",
    "filename": "IMG_4229.PNG",
    "width": 0,
    "height": 0,
    "size": 770261
  },
  {
    "original": "/assets/images/IMG_4230.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4230.PNG",
    "filename": "IMG_4230.PNG",
    "width": 0,
    "height": 0,
    "size": 3345737
  },
  {
    "original": "/assets/images/IMG_4231.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4231.PNG",
    "filename": "IMG_4231.PNG",
    "width": 0,
    "height": 0,
    "size": 3497555
  },
  {
    "original": "/assets/images/IMG_4232.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4232.PNG",
    "filename": "IMG_4232.PNG",
    "width": 0,
    "height": 0,
    "size": 2247354
  },
  {
    "original": "/assets/images/IMG_4233.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_4233.PNG",
    "filename": "IMG_4233.PNG",
    "width": 0,
    "height": 0,
    "size": 1842154
  },
  {
    "original": "/assets/images/IMG_4596.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_4596.JPEG",
    "filename": "IMG_4596.JPEG",
    "width": 0,
    "height": 0,
    "size": 418802
  },
  {
    "original": "/assets/images/IMG_4667.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4667.JPG",
    "filename": "IMG_4667.JPG",
    "width": 0,
    "height": 0,
    "size": 3127113
  },
  {
    "original": "/assets/images/IMG_4668.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4668.JPG",
    "filename": "IMG_4668.JPG",
    "width": 0,
    "height": 0,
    "size": 3313057
  },
  {
    "original": "/assets/images/IMG_4736.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4736.JPG",
    "filename": "IMG_4736.JPG",
    "width": 0,
    "height": 0,
    "size": 1928449
  },
  {
    "original": "/assets/images/IMG_4740.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_4740.JPEG",
    "filename": "IMG_4740.JPEG",
    "width": 0,
    "height": 0,
    "size": 288150
  },
  {
    "original": "/assets/images/IMG_4788.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_4788.JPG",
    "filename": "IMG_4788.JPG",
    "width": 0,
    "height": 0,
    "size": 1582113
  },
  {
    "original": "/assets/images/IMG_5095.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5095.JPG",
    "filename": "IMG_5095.JPG",
    "width": 0,
    "height": 0,
    "size": 1502682
  },
  {
    "original": "/assets/images/IMG_5098.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5098.JPG",
    "filename": "IMG_5098.JPG",
    "width": 0,
    "height": 0,
    "size": 4798770
  },
  {
    "original": "/assets/images/IMG_5099.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5099.JPG",
    "filename": "IMG_5099.JPG",
    "width": 0,
    "height": 0,
    "size": 2505368
  },
  {
    "original": "/assets/images/IMG_5100.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5100.JPG",
    "filename": "IMG_5100.JPG",
    "width": 0,
    "height": 0,
    "size": 2887553
  },
  {
    "original": "/assets/images/IMG_5101.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_5101.PNG",
    "filename": "IMG_5101.PNG",
    "width": 0,
    "height": 0,
    "size": 1586221
  },
  {
    "original": "/assets/images/IMG_5102.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5102.JPG",
    "filename": "IMG_5102.JPG",
    "width": 0,
    "height": 0,
    "size": 4309934
  },
  {
    "original": "/assets/images/IMG_5548.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5548.JPG",
    "filename": "IMG_5548.JPG",
    "width": 0,
    "height": 0,
    "size": 3184305
  },
  {
    "original": "/assets/images/IMG_5612.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_5612.JPEG",
    "filename": "IMG_5612.JPEG",
    "width": 0,
    "height": 0,
    "size": 537502
  },
  {
    "original": "/assets/images/IMG_5613.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_5613.JPEG",
    "filename": "IMG_5613.JPEG",
    "width": 0,
    "height": 0,
    "size": 1001304
  },
  {
    "original": "/assets/images/IMG_5904.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5904.JPG",
    "filename": "IMG_5904.JPG",
    "width": 0,
    "height": 0,
    "size": 1097176
  },
  {
    "original": "/assets/images/IMG_5906.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5906.JPG",
    "filename": "IMG_5906.JPG",
    "width": 0,
    "height": 0,
    "size": 1805552
  },
  {
    "original": "/assets/images/IMG_5908.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5908.JPG",
    "filename": "IMG_5908.JPG",
    "width": 0,
    "height": 0,
    "size": 2979352
  },
  {
    "original": "/assets/images/IMG_5910.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_5910.JPG",
    "filename": "IMG_5910.JPG",
    "width": 0,
    "height": 0,
    "size": 3300762
  },
  {
    "original": "/assets/images/IMG_5911.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_5911.JPEG",
    "filename": "IMG_5911.JPEG",
    "width": 0,
    "height": 0,
    "size": 1268744
  },
  {
    "original": "/assets/images/IMG_5914.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_5914.JPEG",
    "filename": "IMG_5914.JPEG",
    "width": 0,
    "height": 0,
    "size": 1251868
  },
  {
    "original": "/assets/images/IMG_6052.PNG",
    "thumbnail": "/assets/images/thumbnails/IMG_6052.PNG",
    "filename": "IMG_6052.PNG",
    "width": 0,
    "height": 0,
    "size": 24279683
  },
  {
    "original": "/assets/images/IMG_6188.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6188.JPG",
    "filename": "IMG_6188.JPG",
    "width": 0,
    "height": 0,
    "size": 2607157
  },
  {
    "original": "/assets/images/IMG_6189.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6189.JPG",
    "filename": "IMG_6189.JPG",
    "width": 0,
    "height": 0,
    "size": 3551786
  },
  {
    "original": "/assets/images/IMG_6198.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_6198.JPEG",
    "filename": "IMG_6198.JPEG",
    "width": 0,
    "height": 0,
    "size": 1345082
  },
  {
    "original": "/assets/images/IMG_6199.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6199.JPG",
    "filename": "IMG_6199.JPG",
    "width": 0,
    "height": 0,
    "size": 4665968
  },
  {
    "original": "/assets/images/IMG_6200.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_6200.JPEG",
    "filename": "IMG_6200.JPEG",
    "width": 0,
    "height": 0,
    "size": 1525192
  },
  {
    "original": "/assets/images/IMG_6201.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6201.JPG",
    "filename": "IMG_6201.JPG",
    "width": 0,
    "height": 0,
    "size": 2869035
  },
  {
    "original": "/assets/images/IMG_6202.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6202.JPG",
    "filename": "IMG_6202.JPG",
    "width": 0,
    "height": 0,
    "size": 2670286
  },
  {
    "original": "/assets/images/IMG_6794.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6794.JPG",
    "filename": "IMG_6794.JPG",
    "width": 0,
    "height": 0,
    "size": 4313680
  },
  {
    "original": "/assets/images/IMG_6795.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6795.JPG",
    "filename": "IMG_6795.JPG",
    "width": 0,
    "height": 0,
    "size": 5000613
  },
  {
    "original": "/assets/images/IMG_6796.JPG",
    "thumbnail": "/assets/images/thumbnails/IMG_6796.JPG",
    "filename": "IMG_6796.JPG",
    "width": 0,
    "height": 0,
    "size": 3599777
  },
  {
    "original": "/assets/images/IMG_7694.JPEG",
    "thumbnail": "/assets/images/thumbnails/IMG_7694.JPEG",
    "filename": "IMG_7694.JPEG",
    "width": 0,
    "height": 0,
    "size": 154883
  },
  {
    "original": "/assets/images/_DSC3575.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC3575.JPEG",
    "filename": "_DSC3575.JPEG",
    "width": 0,
    "height": 0,
    "size": 725387
  },
  {
    "original": "/assets/images/_DSC3609.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC3609.JPEG",
    "filename": "_DSC3609.JPEG",
    "width": 0,
    "height": 0,
    "size": 672544
  },
  {
    "original": "/assets/images/_DSC3633.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC3633.JPEG",
    "filename": "_DSC3633.JPEG",
    "width": 0,
    "height": 0,
    "size": 460139
  },
  {
    "original": "/assets/images/_DSC5554.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC5554.JPG",
    "filename": "_DSC5554.JPG",
    "width": 0,
    "height": 0,
    "size": 339133
  },
  {
    "original": "/assets/images/_DSC5555.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC5555.JPG",
    "filename": "_DSC5555.JPG",
    "width": 0,
    "height": 0,
    "size": 348130
  },
  {
    "original": "/assets/images/_DSC5556.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC5556.JPG",
    "filename": "_DSC5556.JPG",
    "width": 0,
    "height": 0,
    "size": 348040
  },
  {
    "original": "/assets/images/_DSC5558.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC5558.JPEG",
    "filename": "_DSC5558.JPEG",
    "width": 0,
    "height": 0,
    "size": 272391
  },
  {
    "original": "/assets/images/_DSC5561.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC5561.JPG",
    "filename": "_DSC5561.JPG",
    "width": 0,
    "height": 0,
    "size": 390390
  },
  {
    "original": "/assets/images/_DSC6274.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC6274.JPG",
    "filename": "_DSC6274.JPG",
    "width": 0,
    "height": 0,
    "size": 346304
  },
  {
    "original": "/assets/images/_DSC6282.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC6282.JPG",
    "filename": "_DSC6282.JPG",
    "width": 0,
    "height": 0,
    "size": 7438336
  },
  {
    "original": "/assets/images/_DSC6284.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC6284.JPG",
    "filename": "_DSC6284.JPG",
    "width": 0,
    "height": 0,
    "size": 221582
  },
  {
    "original": "/assets/images/_DSC6291.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6291.JPEG",
    "filename": "_DSC6291.JPEG",
    "width": 0,
    "height": 0,
    "size": 5551525
  },
  {
    "original": "/assets/images/_DSC6292.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6292.JPEG",
    "filename": "_DSC6292.JPEG",
    "width": 0,
    "height": 0,
    "size": 3323797
  },
  {
    "original": "/assets/images/_DSC6293.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6293.JPEG",
    "filename": "_DSC6293.JPEG",
    "width": 0,
    "height": 0,
    "size": 3218618
  },
  {
    "original": "/assets/images/_DSC6294.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6294.JPEG",
    "filename": "_DSC6294.JPEG",
    "width": 0,
    "height": 0,
    "size": 2007971
  },
  {
    "original": "/assets/images/_DSC6295.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6295.JPEG",
    "filename": "_DSC6295.JPEG",
    "width": 0,
    "height": 0,
    "size": 2194451
  },
  {
    "original": "/assets/images/_DSC6296.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6296.JPEG",
    "filename": "_DSC6296.JPEG",
    "width": 0,
    "height": 0,
    "size": 2102654
  },
  {
    "original": "/assets/images/_DSC6297.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6297.JPEG",
    "filename": "_DSC6297.JPEG",
    "width": 0,
    "height": 0,
    "size": 3997989
  },
  {
    "original": "/assets/images/_DSC6298.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6298.JPEG",
    "filename": "_DSC6298.JPEG",
    "width": 0,
    "height": 0,
    "size": 4202903
  },
  {
    "original": "/assets/images/_DSC6299.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6299.JPEG",
    "filename": "_DSC6299.JPEG",
    "width": 0,
    "height": 0,
    "size": 3095825
  },
  {
    "original": "/assets/images/_DSC6300.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6300.JPEG",
    "filename": "_DSC6300.JPEG",
    "width": 0,
    "height": 0,
    "size": 8439523
  },
  {
    "original": "/assets/images/_DSC6306.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6306.JPEG",
    "filename": "_DSC6306.JPEG",
    "width": 0,
    "height": 0,
    "size": 2243512
  },
  {
    "original": "/assets/images/_DSC6308.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6308.JPEG",
    "filename": "_DSC6308.JPEG",
    "width": 0,
    "height": 0,
    "size": 374874
  },
  {
    "original": "/assets/images/_DSC6310.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC6310.JPEG",
    "filename": "_DSC6310.JPEG",
    "width": 0,
    "height": 0,
    "size": 320838
  },
  {
    "original": "/assets/images/_DSC7010.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC7010.JPG",
    "filename": "_DSC7010.JPG",
    "width": 0,
    "height": 0,
    "size": 6717440
  },
  {
    "original": "/assets/images/_DSC7032.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC7032.JPG",
    "filename": "_DSC7032.JPG",
    "width": 0,
    "height": 0,
    "size": 9142272
  },
  {
    "original": "/assets/images/_DSC7033.JPEG",
    "thumbnail": "/assets/images/thumbnails/_DSC7033.JPEG",
    "filename": "_DSC7033.JPEG",
    "width": 0,
    "height": 0,
    "size": 1191996
  },
  {
    "original": "/assets/images/_DSC7034.JPG",
    "thumbnail": "/assets/images/thumbnails/_DSC7034.JPG",
    "filename": "_DSC7034.JPG",
    "width": 0,
    "height": 0,
    "size": 9142272
  },
  {
    "original": "/assets/images/a1c5c30b367a679f3dd3d6ba5ab753c0.JPEG",
    "thumbnail": "/assets/images/thumbnails/a1c5c30b367a679f3dd3d6ba5ab753c0.JPEG",
    "filename": "a1c5c30b367a679f3dd3d6ba5ab753c0.JPEG",
    "width": 0,
    "height": 0,
    "size": 863283
  },
  {
    "original": "/assets/images/a40ce8d1d0b919ff7ca0f2abd4ed2ec4.JPEG",
    "thumbnail": "/assets/images/thumbnails/a40ce8d1d0b919ff7ca0f2abd4ed2ec4.JPEG",
    "filename": "a40ce8d1d0b919ff7ca0f2abd4ed2ec4.JPEG",
    "width": 0,
    "height": 0,
    "size": 567663
  },
  {
    "original": "/assets/images/a6bd7035d7df3312e6703e324eced7e9.JPEG",
    "thumbnail": "/assets/images/thumbnails/a6bd7035d7df3312e6703e324eced7e9.JPEG",
    "filename": "a6bd7035d7df3312e6703e324eced7e9.JPEG",
    "width": 0,
    "height": 0,
    "size": 3966140
  },
  {
    "original": "/assets/images/b853d4cc696137c6b4ec65d9b48bd4de-1.JPEG",
    "thumbnail": "/assets/images/thumbnails/b853d4cc696137c6b4ec65d9b48bd4de-1.JPEG",
    "filename": "b853d4cc696137c6b4ec65d9b48bd4de-1.JPEG",
    "width": 0,
    "height": 0,
    "size": 2947250
  },
  {
    "original": "/assets/images/b853d4cc696137c6b4ec65d9b48bd4de.JPEG",
    "thumbnail": "/assets/images/thumbnails/b853d4cc696137c6b4ec65d9b48bd4de.JPEG",
    "filename": "b853d4cc696137c6b4ec65d9b48bd4de.JPEG",
    "width": 0,
    "height": 0,
    "size": 745449
  },
  {
    "original": "/assets/images/d27c1aa2b6f3f35ddf77b80557ba1a85.JPEG",
    "thumbnail": "/assets/images/thumbnails/d27c1aa2b6f3f35ddf77b80557ba1a85.JPEG",
    "filename": "d27c1aa2b6f3f35ddf77b80557ba1a85.JPEG",
    "width": 0,
    "height": 0,
    "size": 4181485
  },
  {
    "original": "/assets/images/efcf7cf97f91f9fd40d5141bf96b4332.png",
    "thumbnail": "/assets/images/thumbnails/efcf7cf97f91f9fd40d5141bf96b4332.png",
    "filename": "efcf7cf97f91f9fd40d5141bf96b4332.png",
    "width": 0,
    "height": 0,
    "size": 27191192
  },
  {
    "original": "/assets/images/f4d9d7ed587936d346a2b0e16985bf93.png",
    "thumbnail": "/assets/images/thumbnails/f4d9d7ed587936d346a2b0e16985bf93.png",
    "filename": "f4d9d7ed587936d346a2b0e16985bf93.png",
    "width": 0,
    "height": 0,
    "size": 26434038
  },
  {
    "original": "/assets/images/fa19fe6d6541b6c1cfca2026ec74b917.JPEG",
    "thumbnail": "/assets/images/thumbnails/fa19fe6d6541b6c1cfca2026ec74b917.JPEG",
    "filename": "fa19fe6d6541b6c1cfca2026ec74b917.JPEG",
    "width": 0,
    "height": 0,
    "size": 6010066
  },
  {
    "original": "/assets/images/ff1d7bcae4c0623a354cbacbc29ab507.JPEG",
    "thumbnail": "/assets/images/thumbnails/ff1d7bcae4c0623a354cbacbc29ab507.JPEG",
    "filename": "ff1d7bcae4c0623a354cbacbc29ab507.JPEG",
    "width": 0,
    "height": 0,
    "size": 5064500
  }
];
};

// 照片元数据类型
export const PhotoType = {
  original: '',
  thumbnail: '',
  filename: '',
  width: 0,
  height: 0,
  size: 0
};

// 生成缩略图URL
export const getThumbnailUrl = (originalUrl) => {
  return originalUrl.replace('/images/', '/images/thumbnails/');
};

// 检查文件是否是支持的图片格式
export const isSupportedImage = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
};

// 生成照片元数据
export const createPhotoMetadata = (file) => {
  return {
    original: `/assets/images/${file.name}`,
    thumbnail: `/assets/images/thumbnails/${file.name}`,
    filename: file.name,
    width: 0,
    height: 0,
    size: file.size
  };
};
